<template>
  <label-select
    :key="keyIndex"
    v-model="selectValues"
    :popper-class="'multiple_select_popper_' + order + ' ' + $attrs['popper-class'] ? $attrs['popper-class'] : '' + ' my-popper-class'"
    v-bind="$attrs"
    v-on="$listeners"
    :collapse-tags="collapseTags"
    @remove-tag="clearDom"
    multiple
    @focus="selectFocus($el)"
    :label="label"
    @clear="onClear"
    style="display: inline-block;width: 100%;"
    :class="'multiple_select_checkbox multiple_select_checkbox_' + order"
    @visible-change="visibleChange"
    @change="changeSelect"
    :popper-append-to-body='popperAppendToBodys'
  >
    <!-- <el-opti on v-if="options_.length" label="全选" value="全选">
      <el-checkbox v-model="isSelectAll" @click.native.prevent
        >全选</el-checkbox
      >
    </el-option> -->
    <label-select-option
      v-for="item in options_"
      :key="item[props.value]"
      :label="item[props.label]"
      :value="item[props.value]"
      :disabled="item[props.disabled]"
    >
      <!-- <el-tooltip
        :disabled="!item.isExceed"
        :content="item[props.label]"
        placement="top"
        effect="light"
      > -->
        <el-checkbox
          v-if="selectGroup"
          :value="
            selectValues &&
            selectValues.length &&
            selectValues.includes(item[props.value])
          "
          @click.native.prevent
        >
          <div class="select-group-container">
            <div>
              <common-ellipsis-tooltip
                popper-class=''
                effect="dark"
                :content="item[props.label]"
                placement="top"
              >
              </common-ellipsis-tooltip>
              <!--{{ item[props.label] }}-->
            </div>
            <div>
              {{ item[props.message] }}
            </div>
          </div>
        </el-checkbox>
        <el-checkbox
          v-else
          :value="
            selectValues &&
            selectValues.length &&
            selectValues.includes(item[props.value])
          "
          @click.native.prevent
          >
            <common-ellipsis-tooltip
              popper-class=''
              effect="dark"
              :content="item[props.label]"
              placement="top"
            >                
            </common-ellipsis-tooltip>
          </el-checkbox>
      <!-- </el-tooltip> -->
    </label-select-option>
  </label-select>
</template>

<script>
import {
  LabelSelect,
  LabelSelectOption,
} from "@/components/label-input-v2/select";
let keyIndex = 11
export default {
  name: "MultipleSelectCheckbox",
  inheritAttrs: false, // 似乎设不设置都可以
  components: {
    LabelSelect: LabelSelect,
    LabelSelectOption: LabelSelectOption,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // 下拉选项
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    // 选项键值对
    props: {
      type: Object,
      default: () => {
        return {
          label: "label",
          value: "value",
          message: "message",
          disabled: 'disabled'
        };
      },
    },
    // 选项是否独占一行
    isInline: {
      type: Boolean,
      default: false,
    },
    // 是否为组合选项
    selectGroup: {
      type: Boolean,
      default: false,
    },
    // 选项的宽度
    textWidth: {
      type: Number,
    },
    // 组件唯一标识 （避免同一个页面引用多次，发生耦合）
    order: {
      type: Number,
      default: 0,
    },  
    onClear: {
      type: Function,
      default: ()=>{},
    },
    popperAppendToBodys: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      selectValues: this.value,
      isSelectAll: false,
      multipleSelectCheckboxMaxWidth: 0,
      options_: [],
      collapseTags: true,
      keyIndex: '',
    };
  },
  mounted() {
    keyIndex += keyIndex
    this.keyIndex = keyIndex
    const multipleSelectCheckbox = document.querySelector(
      `.multiple_select_checkbox_${this.order}.label-input`
    );
    const elSelectDropdown = document.querySelector(
      `.multiple_select_popper_${this.order}.el-select-dropdown`
    );
    const multipleSelectCheckboxMaxWidth =
      multipleSelectCheckbox && multipleSelectCheckbox.scrollWidth;
    this.multipleSelectCheckboxMaxWidth = multipleSelectCheckboxMaxWidth;
    if(elSelectDropdown) {
      elSelectDropdown.style["max-width"] = multipleSelectCheckboxMaxWidth + "px";
    }
  },
  watch: {
    // 监听（全选or全不选）
    value: {
      handler(arr) {
        this.selectValues = arr;
        // if (this.selectValues.length > 3) {
        //   this.collapseTags = true;
        // } else {
        //   this.collapseTags = false;
        // }
        this.isSelectAll = arr.length === this.options_.length;
      },
    },
    options: {
      handler(arr) {
        this.options_ = JSON.parse(JSON.stringify(arr));
        this.isSelectAll = this.selectValues.length === this.options_.length;
      },
      immediate: true,
    },
  },
  methods: {
    changeSelect(val) {
      if (val && val.length && val.includes("全选")) {
        // 说明已经全选了，所以全不选
        if (val.length > this.options_.length) {
          this.selectValues = [];
        }
        // 反之，全选
        else {
          this.selectValues = this.options_.map(
            (item) => item[this.props.value]
          );
        }
      }
      this.$emit("input", this.selectValues);
    },
    // selectBlur(el) {
    //   this.$nextTick(() => {
    //     el.children[0].style = "color:#ccc;";
    //   });
    // },
    clearDom() {
      this.$emit('delTag')
    },
    selectFocus(el) {
      this.$nextTick(() => {
        el.children[0].style = "color:#4066d4";
      });
    },
    // 判断元素是否溢出，溢出加上toolTip
    async visibleChange(visible) {
      await this.$nextTick();
      if (visible) {
        const maxLableWidth = this.multipleSelectCheckboxMaxWidth - 80;
        const labels = document.querySelectorAll(
          `.multiple_select_popper_${this.order}.el-select-dropdown .el-checkbox.el-tooltip .el-checkbox__label`
        );
        labels.forEach((label, index) => {
          // eslint-disable-next-line no-prototype-builtins
          if (
            this.options_[index] &&
            !Object.prototype.hasOwnProperty.call(
              this.options_[index],
              "isExceed"
            )
          ) {
            this.$set(
              this.options_[index],
              "isExceed",
              label.scrollWidth - 10 > (this.textWidth || maxLableWidth)
            );
            label.style["width"] = this.textWidth + "px";
            label.style["max-width"] = (this.textWidth || maxLableWidth) + "px";
            label.style["vertical-align"] = "middle";
            label.style["overflow"] = "hidden";
            label.style["text-overflow"] = "ellipsis";
            label.style["white-space"] = "nowrap";
          }
        });
        // const items = document.querySelectorAll(
        //   `.multiple_select_popper_${this.order} .el-select-dropdown__item:not(:first-child)`
        // );
        // items.forEach((item) => {
        //   item.style.display = this.isInline ? "inline-block" : "block";
        // });
      } else {
        this.$emit('hideDialog')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .my-popper-class{
  min-width: 100%;
  left:0px !important;
  position: absolute!important;
}
[class*="multiple_select_popper"].el-select-dropdown.is-multiple
  .el-select-dropdown__item.selected::after {
  content: "";
}
.select-group-container {
  div {
    font-weight: 500;
    font-size: 12px;
    font-weight: 500;
    color: #000000;
    &:last-child {
      color: #b2b6c0;
    }
  }
}
.el-select-dropdown__item.is-disabled {
  .el-checkbox {
    cursor: no-drop;
  }
}
::v-deep {
  .el-checkbox__label {
    font-weight: 500;
    font-size: 12px;
    font-weight: 500;
    color: #000000;
  }
}

.multiple_select_checkbox {
  ::v-deep {
    .el-icon-arrow-up:before {
      display: block;
      height: 16px;
      width: 16px;
      content: url("~@/assets/img/share-icon/drop-up.svg");
      transform: translateY(0px) translateX(4px)  !important;
    }
    .el-select__tags {
      flex-wrap: nowrap;
      & > span {
        flex: 1;
        display: flex;
        max-width: 100%;
        span {
          border: none;
          i {
            background: #f4f4f5;
            &::before {
              content: url('../../assets/img/common-icon/icon-16-close.svg');
            }
            &:hover {
              background: #f4f4f5;
              content: url('../../assets/img/common-icon/icon-16-close-hover.svg');
            }
            
          }
        }
      }

    }
    .el-tag--info {
      margin-left: 4px;
      flex-shrink: 0;
      padding: 0 4px;
      .el-select__tags-text {
        font-weight: 500;
        font-size: 12px;
        font-weight: 500;
        color: #000000;
      }
      &:first-child {
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;
        margin-left: 7px;
        .el-select__tags-text {
          flex: 1;
          overflow: hidden;
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .el-tag__close {
          flex-shrink: 0;
          position: initial;
          margin: 0px 0px 0px 4px;
        }
      }
    }
  }
}
.multiple_select_checkbox.is-disabled {
  ::v-deep {
    .el-tag--info {
      background-color: #fff;
      .el-select__tags-text {
        color: #DADCE1;
      }
    }
  }
}

</style>
<style>
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  content: '' !important;
}
.el-select-dropdown.is-multiple 
.el-scrollbar {
  min-width: 180px;
  max-width: 300px;
}
.el-select-dropdown__empty {
  min-width: 110px;
  max-width: 300px;
}
</style>

